'use client'

import { useSyncExternalStore } from 'react'

const emptySubscribe = () => () => {}

/** True after hydration; false during SSR / first server snapshot. */
export function useClientMounted(): boolean {
  return useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false
  )
}
